module.exports = __webpack_public_path__ + "static/media/10.a50b2701.jpg";